// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/_utils.scss");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
exports.push([module.id, "._1xfwq8Y4x{max-width:100%}._7uWkM1iwx{margin:0}._1zQNWk8Bx{max-width:160px}._63G4SbHFx{}._9WTmPsrPx{text-transform:none;font-size:14px}._2CCbqXp7x{}._1SBwwbyix{background-color:rgba(0,0,0,0.1);color:transparent;flex:1 1 100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._1SBwwbyix::after{content:'\\1';color:transparent}@media screen and (-ms-high-contrast: active){._1SBwwbyix{-ms-high-contrast-adjust:none;background:windowText}._1SBwwbyix::after{-ms-high-contrast-adjust:none}}._4KIFtqmgx{width:100%}._608eKmtlx{margin-bottom:6px;height:16px}._4dcfVK9lx{height:18px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"info-label": "_1xfwq8Y4x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-container"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["ellipsize"] + "",
	"infoLabel": "_1xfwq8Y4x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-container"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["ellipsize"] + "",
	"no-margin": "_7uWkM1iwx",
	"noMargin": "_7uWkM1iwx",
	"constrain-width": "_1zQNWk8Bx",
	"constrainWidth": "_1zQNWk8Bx",
	"label-uppercase": "_63G4SbHFx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-label"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["ellipsize"] + "",
	"labelUppercase": "_63G4SbHFx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-label"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["ellipsize"] + "",
	"label": "_9WTmPsrPx _63G4SbHFx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-label"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["ellipsize"] + "",
	"value": "_2CCbqXp7x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-value"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["ellipsize"] + "",
	"skeleton": "_1SBwwbyix " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["skeleton-pulse"] + "",
	"info-label-skeleton": "_4KIFtqmgx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-container"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["ellipsize"] + "",
	"infoLabelSkeleton": "_4KIFtqmgx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["bar-label-container"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["ellipsize"] + "",
	"label-skeleton": "_608eKmtlx _1SBwwbyix " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["skeleton-pulse"] + "",
	"labelSkeleton": "_608eKmtlx _1SBwwbyix " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["skeleton-pulse"] + "",
	"value-skeleton": "_4dcfVK9lx _1SBwwbyix " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["skeleton-pulse"] + "",
	"valueSkeleton": "_4dcfVK9lx _1SBwwbyix " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["skeleton-pulse"] + ""
};
module.exports = exports;
